import { render, staticRenderFns } from "./CadastroGrid.vue?vue&type=template&id=7223b628&scoped=true"
import script from "./CadastroGrid.vue?vue&type=script&lang=js"
export * from "./CadastroGrid.vue?vue&type=script&lang=js"
import style0 from "./CadastroGrid.vue?vue&type=style&index=0&id=7223b628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7223b628",
  null
  
)

export default component.exports